import EndavoLogo from "@/images/endavo_logo.png";
import {
  ENDAVO_GROUP_ID,
  STREAMING_FAITH_GROUP_ID,
  PIKSEL_GROUP_ID,
  IMPACT_NETWORK_GROUP_ID,
  BLUE_PIKSEL_GROUP_ID
} from "./config/constants";

export const STREAMING_FAITH = "streamingFaith";
export const PIKSEL = "piksel";
export const ENDAVO = "default";
export const IMPACT_NETWORK = "impactNetwork";
export const BLUE_PIKSEL = "bluePiksel";

export const themeNamesByGroupId = {
  [ENDAVO_GROUP_ID]: ENDAVO,
  [STREAMING_FAITH_GROUP_ID]: STREAMING_FAITH,
  [PIKSEL_GROUP_ID]: PIKSEL,
  [IMPACT_NETWORK_GROUP_ID]: IMPACT_NETWORK,
  [BLUE_PIKSEL_GROUP_ID]: BLUE_PIKSEL
};

const themes = {
  default: {
    logo: EndavoLogo
  },
  STREAMING_FAITH: {
    logo: ""
  }
};

export const getTheme = (groupId) => {
  const themeName = themeNamesByGroupId?.[groupId] || ENDAVO;

  switch (themeName) {
    case STREAMING_FAITH:
      return themes.STREAMING_FAITH;
    default:
      return themes.default;
  }
};
